export default __webpack_public_path__ + "static/media/timeW.d2fb396a.svg";